<template>

    <div class="layout__padding-clear layout__width-80">
        <div class="layout__position-left layout__width-100">
            <CustomerOrdersSearch v-bind:searchParams="searchParams" v-bind:orders="orders" v-bind:view="view"
                                  v-bind:loading="loading"></CustomerOrdersSearch>
        </div>

        <div class="layout__padding-clear layout__margin__top-30" v-show="this.role === 'Customer'">
            <el-table :data="orders" v-on:row-click="showOrderDetails" v-loading="loading"
                      class="layout__height-600px layout__scrolling__right layout__margin__bottom-30 layout__width-100">
                <el-table-column prop="jobId" label="Order Id">
                </el-table-column>
                <el-table-column prop="billDescription" label="Order Ref">
                </el-table-column>
                <el-table-column prop="status" label="Status">
                </el-table-column>
                <el-table-column prop="ordered" label="Created" :formatter="formatDateDDMMYYYY">
                </el-table-column>
                <el-table-column prop="quantity" label="Qty">
                </el-table-column>
                <el-table-column prop="billGrossTotal" label="Cost (GBP)"
                                 :formatter="returnCurrency">
                </el-table-column>
                <el-table-column label="Download Processed Photo(s)">
                    <template slot-scope="props">
                        <img class="layout__width-20px layout__position-center" v-show="props.row.despatched !== null" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png" v-on:click="downloadCompletedOrder(props.row)">
                        <img class="layout__width-20px layout__position-center" v-show="props.row.despatched === null"
                             :disabled="true" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download-null.png" v-on:click="stopPropagation">
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <div v-show="this.role !== 'PhotoEditor' && this.role !== 'Customer'">
            <el-table :data="orders" v-on:row-click="showOrderDetails"
                      class="layout__height-600px layout__scrolling__right layout__margin__bottom-30"
                      v-loading="loading">
                <el-table-column prop="jobId" label="Order Id">
                </el-table-column>
                <el-table-column prop="billDescription" label="Order Ref">
                </el-table-column>
                <el-table-column prop="status" label="Status">
                </el-table-column>
                <el-table-column prop="ordered" label="Created" :formatter="formatDateDDMMYYYY">
                </el-table-column>
                <el-table-column prop="quantity" label="Qty">
                </el-table-column>
                <el-table-column prop="billGrossTotal" label="Cost (GBP)"
                                 :formatter="returnCurrency">
                </el-table-column>
                <el-table-column label="Download Unprocessed Photo(s)">
                    <template slot-scope="props">
                        <img class="layout__width-20px layout__position-center"
                             v-on:click="downloadOriginalJobBag(props.row)"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png">
                    </template>
                </el-table-column>
                <el-table-column label="Download Processed Photo(s)">
                    <template slot-scope="props">
                        <img class="layout__width-20px layout__position-center" v-show="props.row.despatched !== null" v-on:click="downloadCompletedOrder(props.row)" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png">
                        <img class="layout__width-20px layout__position-center" v-show="props.row.despatched === null"
                             :disabled="true" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download-null.png" v-on:click="stopPropagation">
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!--<Pagination v-bind:orders="orders" v-bind:start="start" v-bind:end="end"-->
                    <!--v-bind:pagination="pagination"></Pagination>-->

        <div class="layout__padding-clear layout__width-60">
            <div class="layout__padding-20-0">
                <el-pagination class="layout__padding-clear"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="this.searchParams.currentPage"
                               :page-sizes="[20, 40, 60, 80, 100]"
                               :page-size="this.searchParams.pagination"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="this.resultsCount">
                </el-pagination>
            </div>
        </div>

    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import CustomerOrdersSearch from '../../components/search/CustomerOrdersSearch';
    import Pagination from "../../components/Pagination";
    import {pagination} from '@/mixins/Pagination.js';

    export default {
        name: "OrderDetails",
        mixins: [axios, csvDownloadHelper, dataFormatter, pagination],
        components: {
            Pagination,
            CustomerOrdersSearch
        },
        props: ['id'],
        data() {
            return {
                adminDisabled: true,
                role: '',
                download: false,
                jobStatus: null,
                loading: false,
                orders: [],
                searchParams: {},
                view: 'Photofixr',
                resultsCount: 0,
            }
        },
        created() {
            console.log('PHOTOFIXR')
            // console.log(this.returnCookie("_customer"))
            if (typeof this.returnCookie("_token") === 'undefined') {
                let parameters = window.location.search.split('=')

                console.log(parameters[1])

                if (parameters[1]) {
                    const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                    Axios.get(getCurrentLoginContext,
                        this.returnHeaderUsingParameter(parameters[1]))

                        .then(response => {
                            this.persistUserSessionUsingParameter(parameters[1], response)
                            console.log('finished persisting the cookies')
                            // EventBus.$emit('customerSearch', this.returnHeaderUsingToken())
                            // EventBus.$emit('update', this.returnAllCookies())
                        });
                }
            } else {
                this.role = JSON.parse(this.returnCookie("_role"))
            }
        },
        methods: {
            showOrderDetails(job) {
                console.log('job id ' + job.sourceId)
                console.log(job)
                this.$router.push({
                    name: '/orders/photofixr/details',
                    params: {
                        orderOverview: job
                    },
                    query: {
                        id: job.sourceId,
                    }
                })
            },
            stopPropagation() {
                event.stopPropagation();
            },
            downloadOriginalJobBag(job) {
                const download = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + job.sourceId + '/download'
                this.downloadLink(event, download)
                event.stopPropagation();
            },
            downloadCompletedOrder(job) {
                const downloadComplete = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + job.sourceId + '/DownloadCompleted'
                this.downloadLink(event, downloadComplete)
                event.stopPropagation();
            },
            resultsPerPage() {
                document.getElementById('getCustomerOrdersPagination').click()
            },
        }
    };
</script>